import React from "react"
import Layout from "../components/Layout"
import { graphql } from "gatsby"
import Blogs from "../components/Blogs"
import SEO from "../components/SEO"


const Blog = ({
  data: {
    allStrapiBlogs: { nodes:  blogs },
   }
  }) => {
  return <Layout>
    <SEO title="Blog" description="AKHADAM AYOUB's blog" />
    <section className="blog-page">
      <Blogs blogs={blogs}  title="All Articles" />
    </section>
  </Layout>
}

export const query = graphql`
  {
    allStrapiBlogs {
      nodes {
        title
        slug
        content
        description
        date(formatString: "MMMM Do YYYY")
        id
        category
        image {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`

export default Blog

